import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authApi } from "../services/api";

// AuthContext gestionează starea admin-ului logat:
// - admin === undefined → încă se verifică sesiunea (loading)
// - admin === null → neautentificat
// - admin === { username, role } → autentificat
const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [admin, setAdmin] = useState(undefined);

  // Verifică sesiunea existentă la mount
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const me = await authApi.me();
        if (!cancelled) setAdmin(me);
      } catch {
        if (!cancelled) setAdmin(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const login = useCallback(async (username, password) => {
    const data = await authApi.login(username, password);
    setAdmin(data);
    return data;
  }, []);

  const logout = useCallback(async () => {
    try {
      await authApi.logout();
    } finally {
      setAdmin(null);
    }
  }, []);

  const value = {
    admin,
    isAuthenticated: !!admin,
    isLoading: admin === undefined,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth trebuie folosit în interiorul <AuthProvider>");
  return ctx;
};
